import { defineStore } from 'pinia'

export const SHEET_Z_INDEX_BASE = 1_002

export const useZIndexStore = defineStore('zIndex', {
  state: () => ({
    next: SHEET_Z_INDEX_BASE,
  }),
  actions: {
    nextZ () {
      return this.next++
    },
    reset () {
      this.next = SHEET_Z_INDEX_BASE
    }
  }
})
